"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAppointmentSchema = exports.createAppointmentSchema = exports.appointmentSchema = void 0;
const zod_1 = require("zod");
const enums_js_1 = require("../enums.js");
const localDate_js_1 = require("../localDate.js");
exports.appointmentSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    serviceType: zod_1.z.enum(enums_js_1.ServiceTypes),
    clientId: zod_1.z.string().uuid().nullable(),
    resourceId: zod_1.z.string().uuid(),
    day: zod_1.z.enum(enums_js_1.DayOfWeeks),
    startMin: localDate_js_1.timeMinSchema,
    endMin: localDate_js_1.timeMinSchema,
    placeOfService: zod_1.z.enum(enums_js_1.PlacesOfService),
    viaTelehealth: zod_1.z.boolean().optional(),
    effectiveFrom: localDate_js_1.localDateSchema,
    effectiveTo: localDate_js_1.localDateSchema.nullable().optional(),
    source: zod_1.z.enum(enums_js_1.ApptSources),
    notes: zod_1.z.string().nullable().optional(),
});
exports.createAppointmentSchema = zod_1.z.object({
    serviceType: zod_1.z.enum(enums_js_1.ServiceTypes),
    clientId: zod_1.z.string().uuid().optional(),
    resourceId: zod_1.z.string().uuid(),
    day: zod_1.z.enum(enums_js_1.DayOfWeeks),
    startMin: localDate_js_1.timeMinSchema,
    endMin: localDate_js_1.timeMinSchema,
    placeOfService: zod_1.z.enum(enums_js_1.PlacesOfService),
    viaTelehealth: zod_1.z.boolean().optional().default(false),
    effectiveFrom: localDate_js_1.localDateSchema.optional(),
    effectiveTo: localDate_js_1.localDateSchema.optional(),
    source: zod_1.z.enum(enums_js_1.ApptSources).default('MANUAL'),
    notes: zod_1.z.string().optional(),
    overrideReason: zod_1.z.string().optional(),
});
exports.updateAppointmentSchema = exports.createAppointmentSchema.partial();
//# sourceMappingURL=appointment.js.map